import { useEffect } from "react";
import { motion } from "framer-motion";
import { PHONE } from "@/lib/site";

const EASE = [0.16, 1, 0.3, 1];

const faqs = [
  { q: "Which is the best Bollywood nightclub in Goa?", a: "Soho Goa on Calangute–Baga Road is among the best Bollywood nightclubs in Goa — weekly Bollywood, BollyTech and commercial nights with headline DJs, a packed floor and full table service, open 9 PM till late." },
  { q: "Where is Soho Goa nightclub located?", a: "Soho Goa is on Calangute–Baga Road, Baga, Arpora, North Goa 403516 — a few minutes from Tito's Lane, Baga Beach and Calangute Beach. Use the Get directions button on this page for a straight route." },
  { q: "What is the cover charge at Soho Goa?", a: "Cover charge changes by night and entry type — couple, stag (single male) and female entry are priced separately for each event. Pay online via UPI and show your verified gate pass at the door." },
  { q: "How do I book a table at Soho Goa, Baga?", a: `Message us on WhatsApp or call ${PHONE} — table reservations are confirmed within minutes. Walk-ins are welcome, but tables sell out fast on Fridays and Saturdays.` },
  { q: "Which nights have Bollywood events at Soho Goa?", a: "Bollywood and commercial nights run most of the week — check the What's On section above for this week's lineup. Friday and Saturday are the biggest nights, and midweek often brings ladies-night offers." },
  { q: "What time does Soho Goa open?", a: "Doors open at 9 PM and the floor runs till late, every night of the week." },
];

export const FaqSection = () => {
  useEffect(() => {
    const schema = { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })) };
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "faq-schema";
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => { document.getElementById("faq-schema")?.remove(); };
  }, []);
  return (
    <section className="faq-section" id="faq" data-testid="faq-section">
      <div className="section-head">
        <div>
          <p className="chapter"><b>04</b> Good to know</p>
          <h2>Before you <em>go out.</em></h2>
        </div>
      </div>
      <div className="faq-list">
        {faqs.map((f, i) => (
          <motion.details className="faq-item" key={i} data-testid={`faq-item-${i}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, ease: EASE, delay: i * 0.08 }}>
            <summary>{f.q}</summary>
            <p>{f.a}</p>
          </motion.details>
        ))}
      </div>
    </section>
  );
};
